var map = {
	"./story0.webp": "9e10",
	"./story1.webp": "17fe",
	"./story2.webp": "1a81",
	"./story3.webp": "44c0",
	"./story4.webp": "26c7",
	"./story5.webp": "361f",
	"./story6.webp": "ecbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c382";